export default "__VITE_ASSET__CwhLX1f7__"